@if (disabled) {
  <button data-ripple-light="true" [class]="disabledClass" disabled>
    <div class="flex items-center justify-center">
      @if (faIcon != null && !IconRight) {
        <fa-icon class="mr-1" [icon]="faIcon" />
      }
      {{text}}
      @if (faIcon != null && IconRight) {
        <fa-icon class="ml-1" [icon]="faIcon" />
      }
    </div>
  </button>
}
@if (!disabled) {
  <button data-ripple-light="true" [style]="class">
    <div class="flex items-center justify-center">
      @if (faIcon != null && !IconRight) {
        <fa-icon class="mr-1" [icon]="faIcon" />
      }
      {{text}}
      @if (faIcon != null && IconRight) {
        <fa-icon class="ml-1" [icon]="faIcon" />
      }
    </div>
  </button>
}
